<ng-container *ngIf="displayTags.length; else emptyState">
	<div class="tag-pill-list" role="list">
		<span
			class="tag-pill"
			[ngClass]="'tag-pill--' + pillSize"
			role="listitem"
			*ngFor="let tag of displayTags"
		>
			<span class="tag-pill__dot" [style.background]="tag.dotColor"></span>
			<span class="tag-pill__label">
				{{ tag.label }}
			</span>
			<button
				type="button"
				class="tag-pill__clear"
				aria-label="Remove {{ tag.label }} tag"
				(click)="clearTag(tag, $event)"
			>
				<svg viewBox="0 0 8 8" aria-hidden="true" focusable="false">
					<path d="M1 1 L7 7 M7 1 L1 7" />
				</svg>
			</button>
		</span>
	</div>
</ng-container>

<ng-template #emptyState>
	<span class="tag-pill-empty"></span>
</ng-template>
